import { useEffect, useState } from 'react'
import { toast } from 'sonner'

import { updateProductTitle } from '@/api/api'
import { Button } from '@/components/ui/button'
import { Dialog, DialogContent, DialogFooter, DialogHeader, DialogTitle } from '@/components/ui/dialog'
import { Input } from '@/components/ui/input'
import { useSubmitLock } from '@/hooks/useSubmitLock'

type Props = {
  open: boolean
  onOpenChange: (open: boolean) => void
  productId: number
  currentTitle: string
  onUpdated: (title: string) => void
}

export const ProductTitleEditDialog = ({ open, onOpenChange, productId, currentTitle, onUpdated }: Props) => {
  const [title, setTitle] = useState(currentTitle)
  const { isSubmitting, run } = useSubmitLock()

  useEffect(() => {
    if (open) setTitle(currentTitle)
  }, [open, currentTitle])

  const handleSubmit = async () => {
    const trimmed = title.trim()
    if (!trimmed || trimmed === currentTitle) {
      onOpenChange(false)
      return
    }
    await run(async () => {
      try {
        const res = await updateProductTitle(productId, trimmed)
        onOpenChange(false)
        onUpdated(res.title)
        toast.success('タイトルを変更しました')
      } catch (error) {
        console.error('Failed to update product title:', error)
        toast.error('タイトルの変更に失敗しました')
      }
    })
  }

  return (
    <Dialog
      open={open}
      onOpenChange={(next) => {
        if (isSubmitting && !next) return
        onOpenChange(next)
      }}
    >
      <DialogContent className="max-w-md" onClick={(e) => e.stopPropagation()}>
        <DialogHeader>
          <DialogTitle>タイトルを変更</DialogTitle>
        </DialogHeader>

        <Input
          value={title}
          onChange={(e) => setTitle(e.target.value)}
          maxLength={500}
          autoFocus
          onKeyDown={(e) => {
            if (e.key === 'Enter') void handleSubmit()
          }}
        />

        <DialogFooter>
          <Button variant="outline" onClick={() => onOpenChange(false)} disabled={isSubmitting}>
            キャンセル
          </Button>
          <Button onClick={() => void handleSubmit()} disabled={isSubmitting || !title.trim()}>
            {isSubmitting ? '変更中...' : '変更'}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  )
}
